import LayingUp from './LayingUp';

export default LayingUp;
